/**
 * Web Platform
 * 
 * Для standalone веб-версии и embed
 */

const BROWSER_ID_KEY = 'beshek_uid';

class WebPlatform {
  private browserId: string | null = null;
  
  /**
   * Инициализация
   */
  async init(): Promise<void> {
    this.getBrowserId();
    console.log('[WEB] Initialized, browserId:', this.browserId);
  }
  
  /**
   * Получить или создать Browser ID
   */
  getBrowserId(): string {
    if (this.browserId) return this.browserId;
    
    // Пробуем получить из localStorage
    try {
      let id = localStorage.getItem(BROWSER_ID_KEY);
      
      if (!id) {
        // Генерируем новый
        id = `br_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
        localStorage.setItem(BROWSER_ID_KEY, id);
      }
      
      this.browserId = id;
    } catch {
      // localStorage недоступен (incognito и т.д.)
      this.browserId = `br_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    }
    
    return this.browserId;
  }
  
  /**
   * Очистить Browser ID (logout)
   */
  clearBrowserId(): void {
    try {
      localStorage.removeItem(BROWSER_ID_KEY);
    } catch {}
    this.browserId = null;
  }
  
  /**
   * Имя пользователя (гость)
   */
  getDisplayName(): string {
    return 'Гость';
  }
  
  /**
   * Аватар
   */
  getAvatar(): string | null {
    return null;
  }
  
  /**
   * Хаптик (недоступен в браузере)
   */
  haptic(): void {
    // Нет вибрации в браузере
  }
  
  /**
   * Поделиться
   */
  async share(text: string, url?: string): Promise<boolean> {
    const shareData = {
      text,
      url: url || window.location.href,
    };
    
    // Пробуем Web Share API
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return true;
      } catch {
        // Пользователь отменил или ошибка
      }
    }
    
    // Fallback - копируем в буфер
    const fullText = url ? `${text}\n${url}` : text;
    try {
      await navigator.clipboard.writeText(fullText);
      window.dispatchEvent(new CustomEvent('app-toast', { detail: { message: 'Скопировано в буфер обмена!' } }));
      return true;
    } catch {
      // Не можем скопировать
      return false;
    }
  }
  
  /**
   * Показать алерт
   */
  showAlert(message: string): void {
    window.dispatchEvent(new CustomEvent('app-toast', { detail: { message } }));
  }
  
  /**
   * Закрыть (ничего не делает в браузере)
   */
  close(): void {
    // В браузере не закрываем вкладку
  }
}

// Singleton
export const webPlatform = new WebPlatform();
